// 주문 필터 — 공용 SegmentedControl 사용 (TASK-02-A)
import { SegmentedControl } from '@/components/ui/SegmentedControl';
import type { FilterType, OrderHistoryTranslations } from './types';

interface OrderFilterTabsProps {
  selectedFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
  translations: OrderHistoryTranslations;
}

export function OrderFilterTabs({
  selectedFilter,
  onFilterChange,
  translations,
}: OrderFilterTabsProps) {
  const options = [
    { id: 'all', label: translations.all },
    { id: 'pickup', label: translations.pickup },
    { id: 'table', label: translations.table },
  ];

  return (
    <div className="bg-background shadow-sm">
      <SegmentedControl
        options={options}
        value={selectedFilter}
        onValueChange={(v) => onFilterChange(v as FilterType)}
        className="w-full"
        itemClassName="flex-1"
        ariaLabel={translations.all}
      />
    </div>
  );
}
